/**
 * Footer component for professional theme.
 */
import React from 'react';
import './Footer.css';

export const ProfessionalFooter: React.FC = () => {
  return (
    <footer className="professional-footer">
      <div className="footer-content">
        <p className="footer-text">
          Copyright 2025 Rob Kooper
        </p>
      </div>
    </footer>
  );
};

